import { fetchAuthSession, confirmUserAttribute, updateUserAttributes, getCurrentUser } from 'aws-amplify/auth'
import { Hub } from 'aws-amplify/utils'


export const verifyEmailCode = async (verificationCode) => {
    try {
        // Verificar el código de verificación de email
        let verifyEmail = await confirmUserAttribute({ userAttributeKey: 'email', confirmationCode: verificationCode });
        console.log('Email verificado correctamente:', verifyEmail);
        if(verifyEmail){
            return { success: true, message: 'El código de verificación ha sido validado correctamente.' };

        }
        return { success: false, message: 'El código de verificación no se ha podido validar correctamente.' }
        // Si se verifica correctamente, retorna true
    } catch (error) {
        // Manejo de errores más detallado
        if (error.code === 'CodeMismatchException') {
            console.error('Código de verificación incorrecto:', error.message);
            return { success: false, message: 'El código de verificación es incorrecto.' };
        } else if (error.code === 'ExpiredCodeException') {
            console.error('El código ha expirado:', error.message);
            return { success: false, message: 'El código de verificación ha expirado. Solicita uno nuevo.' };
        } else if (error.code === 'NetworkError') {
            console.error('Error de red:', error.message);
            return { success: false, message: 'Error de conexión. Verifica tu red e intenta nuevamente.' };
        } else {
            console.error('Error desconocido al verificar el email:', error);
            return { success: false, message: 'Ocurrió un error al verificar el email. Intenta nuevamente más tarde.' };
        }
    }
}

export const verifyPhoneNumberCode = async (verificationPhoneCode) => {
    try {
        console.log('verificationPhoneCode',verificationPhoneCode)
        let verifyPhone = await confirmUserAttribute({ userAttributeKey: 'phone_number', confirmationCode: verificationPhoneCode })
        console.log('Número de teléfono verificado correctamente', verifyPhone)
        if(verifyPhone){
            return { success: true, message: 'El código de verificación de phone ha sido validado correctamente.' };

        }
        return { success: false, message: 'El código de verificación de phone no se ha podido validar correctamente.' }
    } catch (error) {
        console.error('Error verificando el teléfono:', error)
        if (error.code === 'CodeMismatchException') {
            console.error('Código de verificación incorrecto:', error.message);
            return { success: false, message: 'El código de verificación es incorrecto. Verifica el código y vuelve a intentarlo.' };
        } else if (error.code === 'ExpiredCodeException') {
            console.error('El código ha expirado:', error.message);
            return { success: false, message: 'El código de verificación ha expirado. Solicita uno nuevo.' };
        } else if (error.code === 'NetworkError') {
            console.error('Error de red:', error.message);
            return { success: false, message: 'Hubo un problema de red. Verifica tu conexión e intenta nuevamente.' };
        } else if (error.code === 'NotAuthorizedException') {
            console.error('No autorizado:', error.message);
            return { success: false, message: 'No tienes autorización para verificar este número de teléfono.' };
        } else if (error.code === 'UserNotFoundException') {
            console.error('Usuario no encontrado:', error.message);
            return { success: false, message: 'No se ha encontrado un usuario asociado a este número de teléfono.' };
        } else {
            console.error('Error desconocido:', error.message);
            return { success: false, message: 'Ocurrió un error inesperado. Intenta nuevamente más tarde.' };
        }
    }
}

export const updateAttributesCognito = async (fields, user) => { 


    try {

        let updatedAttributes = fields

        if(updatedAttributes['last_name']){
            let { last_name: family_name, ...rest } = updatedAttributes;
            updatedAttributes = { family_name, ...rest };

        }
        if(updatedAttributes['phone']){
            let { phone: phone_number, ...rest } = updatedAttributes;
            updatedAttributes = { phone_number, ...rest };

        }


        if (Object.keys(updatedAttributes).length > 0) {
            try {
                console.log('updatedAttributes', updatedAttributes)
                let update = await updateUserAttributes({ userAttributes: updatedAttributes });
                console.log('Actualización exitosa:', update);
                return { success: true, message: 'Los atributos se actualizaron correctamente.' };
            } catch (error) {
                // Manejo de errores específicos de Cognito
                if (error.code === 'InvalidParameterException') {
                    console.error('Parámetros inválidos:', error.message);
                    return { success: false, message: 'Uno o más parámetros son inválidos. Revisa los datos ingresados.' };
                } else if (error.code === 'NetworkError') {
                    console.error('Error de red:', error.message);
                    return { success: false, message: 'No se pudo conectar a la red. Intenta nuevamente.' };
                } else if (error.code === 'NotAuthorizedException') {
                    console.error('No autorizado:', error.message);
                    return { success: false, message: 'No tienes autorización para actualizar estos atributos.' };
                } else if (error.code === 'UserNotFoundException') {
                    console.error('Usuario no encontrado:', error.message);
                    return { success: false, message: 'El usuario no fue encontrado en Cognito.' };
                } else {
                    console.error('Error desconocido:', error.message);
                    return { success: false, message: 'Ocurrió un error inesperado. Intenta nuevamente más tarde.' };
                }
            }
        } else {
            return { success: false, message: 'No se proporcionaron atributos para actualizar.' };
        }

    } catch (error) {
        console.error('error',error)
    }
}
